<div class="table-wrapper"
  [class.minitable]="minitable">

  <table class="admin-table"
    mat-table
    matSort
    [dataSource]="dataSource">
    @for (column of columns; track column.title) {
    <!-- Text -->
    @if (column.type === ColumnType.Text) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        class="text-header"
        *matHeaderCellDef>
        @if (column.sortDescOnly) {
        <span class="sort-title" (click)="onSortString(column.def, false)">{{ column.title }}</span>
        } @else {
        {{ column.title }}
        <mat-icon class="icon-up"
          (click)="onSortString(column.def, true)">
          arrow_drop_up
        </mat-icon>
        <mat-icon class="icon-down"
          (click)="onSortString(column.def, false)">
          arrow_drop_down
        </mat-icon>
        }
      </th>
      <td mat-cell
        class="text-column"
        *matCellDef="let element">
        {{ element[column.def] | newLine : ',' : '\n' }}
      </td>
    </ng-container>
    }
    <!-- Title with optional link -->
    @if (column.type === ColumnType.TitleLink) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        class="text-header"
        *matHeaderCellDef>
        {{ column.title }}
        <mat-icon class="icon-up"
          (click)="onSortString(column.def, true)">
          arrow_drop_up
        </mat-icon>
        <mat-icon class="icon-down"
          (click)="onSortString(column.def, false)">
          arrow_drop_down
        </mat-icon>
      </th>
      <td mat-cell
        class="text-column"
        *matCellDef="let element">
        <div class="title-link-cell">
          <div class="title-link-top">
            {{ element[column.def] }}
          </div>
          @if ((column.subtitleFn ? column.subtitleFn(element) : (column.subtitleDef && element[column.subtitleDef])) || element.embeddedCode) {
          <div class="title-link-subtitle">
            @if (element.embeddedCode) {
            <mat-icon class="title-link-icon"
              (click)="onLink($event, element)">
              link
            </mat-icon>
            }
            {{ column.subtitleFn ? column.subtitleFn(element) : element[column.subtitleDef!] }}
          </div>
          }
        </div>
      </td>
    </ng-container>
    }
    <!-- Long Text -->
    @if (column.type === ColumnType.LongText) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        *matHeaderCellDef>
        {{ column.title }}
      </th>
      <td mat-cell
        [ngClass]="column.type"
        [title]="element[column.def]"
        *matCellDef="let element">
        {{ element[column.def] }}
      </td>
    </ng-container>
    }
    <!-- Break Text -->
    @if (column.type === ColumnType.BreakText) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        *matHeaderCellDef>
        {{ column.title }}
      </th>
      <td mat-cell
        (click)="cellClickEmitter.next(element[column.def])"
        [ngClass]="column.type"
        *matCellDef="let element">
        {{ element[column.def] }}
      </td>
    </ng-container>
    }
    <!-- HTML -->
    @if (column.type === ColumnType.Html) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        *matHeaderCellDef>
        {{ column.title }}
      </th>
      <td mat-cell
        class="inner-html"
        *matCellDef="let element">
        <div class="html"
          [innerHtml]="element[column.def]">
        </div>
      </td>
    </ng-container>
    }
    <!-- Number -->
    @if (column.type === ColumnType.Number) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        class="number"
        *matHeaderCellDef>
        @if (column.sortDescOnly) {
        <span class="sort-title" (click)="onSortNumber(column.def, false)">{{ column.title }}</span>
        } @else {
        {{ column.title }}
        <mat-icon class="icon-up"
          (click)="onSortNumber(column.def, true)">
          arrow_drop_up
        </mat-icon>
        <mat-icon class="icon-down"
          (click)="onSortNumber(column.def, false)">
          arrow_drop_down
        </mat-icon>
        }
      </th>
      <td mat-cell
        class="number"
        [class.rank-gold]="getRank(element, column.def) === 1"
        [class.rank-green]="getRank(element, column.def) === 2"
        [class.rank-blue]="getRank(element, column.def) === 3"
        *matCellDef="let element">
        @if (column.decimals) {
          {{ element[column.def] | number: '1.2-2' }}
        } @else {
          {{ Math.round(element[column.def]) | number: '1.0-0' }}
        }
      </td>
    </ng-container>
    }
    <!-- ArrayCount -->
    @if (column.type === ColumnType.ArrayCount) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        class="number"
        *matHeaderCellDef>
        {{ column.title }} <mat-icon class="icon-up"
          (click)="onSortCounter(column.def, true)">
          arrow_drop_up
        </mat-icon>
        <mat-icon class="icon-down"
          (click)="onSortCounter(column.def, false)">
          arrow_drop_down
        </mat-icon>
      </th>
      <td mat-cell
        class="number"
        *matCellDef="let element">
        {{ setCount(element[column.def]) }}
      </td>
    </ng-container>
    }
    <!-- Instagram -->
    @if (column.type === ColumnType.Instagram) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        class="instagram"
        *matHeaderCellDef>
        <span class="header-table">
          {{ column.title }}
          <mat-icon class="sort-icon red"
            (click)="onSortByParam('created')">
            schedule
          </mat-icon>
          <mat-icon class="sort-icon"
            (click)="onSortByParam('views')">
            visibility
          </mat-icon>
          <mat-icon class="sort-icon"
            (click)="onSortByParam('reach')">
            person
          </mat-icon>
          <mat-icon class="sort-icon blue"
            (click)="onSortByParam('likes')">
            thumb_up
          </mat-icon>
          <mat-icon class="sort-icon red"
            (click)="onSortByParam('comments')">
            comment
          </mat-icon>
          <mat-icon class="sort-icon red"
            (click)="onSortByParam('shares')">
            share
          </mat-icon>
          <mat-icon class="sort-icon red"
            (click)="onSortByParam('saves')">
            star
          </mat-icon>
          <mat-icon class="sort-icon red"
            (click)="onSortByParam('reposts')">
            repeat
          </mat-icon>
          <mat-icon class="sort-icon red"
            (click)="onSortByParam('profileVisits')">
            pageview
          </mat-icon>
          <mat-icon class="sort-icon red"
            (click)="onSortByParam('follows')">
            person_add
          </mat-icon>
          <mat-icon class="sort-icon red"
            (click)="onSortByParam('nonFollowers')">
            group
          </mat-icon>
          <mat-icon class="sort-icon green"
            (click)="onSortByParam('rating')">
            grade
          </mat-icon>
        </span>
      </th>
      <td mat-cell
        class="instagram"
        *matCellDef="let element">
        <div>
          <mat-icon class="table-icon">visibility</mat-icon>
          <span>{{ element.views | number: '1.0-0' }}</span>
          <span
            [style.color]="element.views / element.reach > 3.0 ? '#4caf50' : element.views / element.reach < 1.2 ? '#E97451' : null">{{element.views
            / element.reach | number:'1.1-1' }}</span>
        </div>
        <div class="shorter">
          <mat-icon class="table-icon">person</mat-icon>
          <span>{{ element.reach | number: '1.0-0' }}</span>
        </div>
        <div>
          <mat-icon class="table-icon">thumb_up</mat-icon>
          <span>{{ element.likes | number: '1.0-0' }}</span>
          <span>{{element.likes / element.reach | percent:'1.1-1' }}</span>
        </div>
        <div class="other-stats">
          <span>{{ (element.comments | number: '1.0-0' ) || '-'}}</span>
          <mat-icon class="table-icon">comment</mat-icon>
          <span>{{( element.shares | number: '1.0-0' ) || '-'}}</span>
          <mat-icon class="table-icon">share</mat-icon>
          <span>{{ (element.saves | number: '1.0-0' ) || '-'}}</span>
          <mat-icon class="table-icon">star</mat-icon>
          <span>{{ (element.reposts | number: '1.0-0') || '-' }}</span>
          <mat-icon class="table-icon">repeat</mat-icon>
          <span>{{ (element.profileVisits | number: '1.0-0' ) || '-'}}</span>
          <mat-icon class="table-icon">pageview</mat-icon>
          <span>{{ (element.follows | number: '1.0-0') || '-'}}</span>
          <mat-icon class="table-icon">person_add</mat-icon>
          <span>{{ element.nonFollowers ? (element.nonFollowers | number: '1.0-0') + '%' : '-' }}</span>
          <mat-icon class="table-icon">group</mat-icon>
        </div>
      </td>
    </ng-container>
    }
    <!-- Rating -->
    @if (column.type === ColumnType.Rating) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        class="rating-header"
        *matHeaderCellDef>
        {{ column.title }}
      </th>
      <td mat-cell
        class="rating-cell"
        *matCellDef="let element">
        @if (element[column.def] != null) {
        <span class="rating-box"
          [class.rating-blue]="element[column.def] > 99"
          [class.rating-green]="element[column.def] > 50 && element[column.def] <= 99"
          [class.rating-yellow]="element[column.def] > 25 && element[column.def] <= 50"
          [class.rating-orange]="element[column.def] > 9 && element[column.def] <= 25"
          [class.rating-red]="element[column.def] <= 9">
          {{ element[column.def] | number: '1.0-0' }}
        </span>
        }
      </td>
    </ng-container>
    }
    <!-- Color -->
    @if (column.type === ColumnType.Color) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        *matHeaderCellDef>
        {{ column.title }}
      </th>
      <td mat-cell
        *matCellDef="let element">
        <div class="color-column"
          [style.background]="element[column.def]">
          {{ element[column.def] }}
        </div>
      </td>
    </ng-container>
    }
    <!-- Boolean -->
    @if (column.type === ColumnType.Boolean) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        class="boolean"
        *matHeaderCellDef>
        {{ column.title }}
      </th>
      <td mat-cell
        class="boolean"
        *matCellDef="let element">
        @if (element[column.def]) {
        <mat-icon class="color-good">check</mat-icon>
        }
        @if (!element[column.def]) {
        <mat-icon class="color-bad">clear</mat-icon>
        }
      </td>
    </ng-container>
    }
    <!-- Checkbox -->
    @if (column.type === ColumnType.Check) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        *matHeaderCellDef>
        {{ column.title }}
      </th>
      <td mat-cell
        *matCellDef="let element">
        <mat-checkbox [checked]="element[column.def]"
          (change)="checkBoxEmitter.next(element)"></mat-checkbox>
      </td>
    </ng-container>
    }
    <!-- Date -->
    @if (column.type === ColumnType.Date) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        *matHeaderCellDef>
        {{ column.title }}
      </th>
      <td mat-cell
        *matCellDef="let element">
        <span [class.red]="olderThan2Months(element, column)"
          [class.yellow]="olderThan2Weeks(element, column)">
          {{ element[column.def] | date : "d. M. yyyy." }}
          <br>
          <br>
          {{ element[column.def] | date : "H:mm" }}
        </span>
      </td>
    </ng-container>
    }
    <!-- Dates (created + updated) -->
    @if (column.type === ColumnType.Dates) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        *matHeaderCellDef>
        {{ column.title }}
      </th>
      <td mat-cell
        *matCellDef="let element">
        <div class="dates-cell">
          <div class="date-created">
            <mat-icon class="dates-icon">add_circle</mat-icon>
            <span [title]="element.created | date : 'd. M. yyyy.'">{{ element.created | relativeTime }}</span>
          </div>
          <div>
            <mat-icon class="dates-icon">build_circle</mat-icon>
            <span [title]="element.updated | date : 'd. M. yyyy.'">{{ element.updated | relativeTime }}</span>
          </div>
        </div>
      </td>
    </ng-container>
    }
    <!-- List -->
    @if (column.type === ColumnType.List) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        *matHeaderCellDef>
        {{ column.title }}
      </th>
      <td mat-cell
        *matCellDef="let element">
        <div class="list-items">
          {{ handleList(column, element[column.def]) }}
        </div>
      </td>
    </ng-container>
    }
    <!-- Link -->
    @if (column.type === ColumnType.Link) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        *matHeaderCellDef>
        {{ column.title }}
      </th>
      <td mat-cell
        *matCellDef="let element">
        <a [href]="element[column.def]"
          target="_blank"
          rel="noopener noreferrer">
          {{ element[column.def] }}</a>
      </td>
    </ng-container>
    }
    <!-- Embedded -->
    @if (column.type === ColumnType.Embedded) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        *matHeaderCellDef>
        {{ column.title }}
      </th>
      <td mat-cell
        *matCellDef="let element">
        <a [href]="element[column.def]"
          target="_blank"
          (click)="onLink($event, element)"
          rel="noopener noreferrer">
          <mat-icon>link</mat-icon></a>
      </td>
    </ng-container>
    }
    <!-- Embedded + Actions -->
    @if (column.type === ColumnType.LinkActions) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        *matHeaderCellDef>
        {{ column.title }}
      </th>
      <td mat-cell
        *matCellDef="let element">
        <button mat-button
          (click)="onLink($event, element)">
          <mat-icon class="embedded-link-icon">link</mat-icon>
        </button>
        <button mat-button
          (click)="editEmitter.next(element)"
          (contextmenu)="rightClickEmitter.next(element)">
          <mat-icon class="embedded-edit-icon">construction</mat-icon>
        </button>
        <button mat-button
          (click)="deleteEmitter.next(element.id)">
          <mat-icon class="embedded-delete-icon">delete</mat-icon>
        </button>
      </td>
    </ng-container>
    }
    <!-- Image -->
    @if (column.type === ColumnType.Image) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        class="image"
        *matHeaderCellDef>
        {{ column.title }}
      </th>
      <td mat-cell
        class="image"
        *matCellDef="let element">
        <ng-container>
          <img class="table-thumb"
            loading="lazy"
            [src]="element[column.def]"
            appDefaultLogo
            [alt]="element[column.def]" />
        </ng-container>
      </td>
    </ng-container>
    }
    <!-- Image STARS -->
    @if (column.type === ColumnType.ImageStars) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        class="image"
        *matHeaderCellDef>
        {{ column.title }}
        <mat-icon class="icon-down"
          (click)="onStarSort()">
          arrow_drop_down
        </mat-icon>
      </th>
      <td mat-cell
        class="image"
        *matCellDef="let element">
        <ng-container>
          <div class="img-stars">
            <img class="table-thumb"
              loading="lazy"
              [src]="element[column.def]"
              appDefaultLogo
              [alt]="element[column.def]" />
            <div class="stars">
              @if (element.frontPage) {
              ★★★
              } @else if (element.topTen) {
              ★★
              } @else if (element.localHero) {
              ★
              }
            </div>
          </div>
        </ng-container>
      </td>
    </ng-container>
    }
    <!-- Actions -->
    @if (column.type === ColumnType.Actions) {
    <ng-container [matColumnDef]="column.def">
      <th mat-header-cell
        *matHeaderCellDef>
        {{ column.title }}
      </th>
      <td mat-cell
        *matCellDef="let element">
        @if (extraButton) {
        <button mat-button
          (click)="extraButtonEmitter.next(element)">
          <mat-icon class="bio">face</mat-icon>
        </button>
        }
        <button mat-button
          (click)="editEmitter.next(element)"
          (contextmenu)="rightClickEmitter.next(element)">
          <mat-icon class="edit">construction</mat-icon>
        </button>
        <button mat-button
          (click)="deleteEmitter.next(element.id)">
          <mat-icon class="delete">delete</mat-icon>
        </button>
      </td>
    </ng-container>
    }
    }

    <tr mat-header-row
      *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row
      *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator pageSize="10"
    showFirstLastButtons />
</div>